export default __webpack_public_path__ + "static/media/Graphic.d722f800.png";